import { Injectable } from "@angular/core";
import { StakedTradeStateService } from "@modules/staking/domain/+state/staked-trade.state.service";
import { Observable } from "rxjs";
import { Stakeable } from "@modules/staking/domain/entities/stakeable.model";
import { map, take } from "rxjs/operators";
import { GetStakeableDataByIdQuery } from "../../../../api/graphql/staking/generated/staking.stakeable-info-by-id.service.graphql-gen";
import { StakingHelperService } from "@modules/staking/domain/+state/utility/staking-helper.service";
import { StakingAdpRemote } from "@modules/staking/domain/infrastructure/staking-adp.remote";

@Injectable({
	providedIn: "root"
})
export class StakedTradeFacade {
	public constructor(
		private readonly stakedTradeStateService: StakedTradeStateService,
		private readonly stakingHelperService: StakingHelperService,
		private readonly stakingAdpRemote: StakingAdpRemote
	) {}

	public getTradeStakeable(): Observable<Stakeable> {
		return this.stakedTradeStateService.getStakeable$();
	}

	public updateStakeable(stakeable: Stakeable): void {
		this.stakedTradeStateService.updateWidgetState({ stakeable: stakeable });
	}

	public removeStakeable(): void {
		this.stakedTradeStateService.updateWidgetState({ stakeable: null });
	}

	public isStakedAsset$(): Observable<boolean> {
		return this.getTradeStakeable().pipe(map((stakeable: Stakeable) => +stakeable?.stakedAmount > 0));
	}

	public fetchStakeableDataById$(assetId: string): void {
		this.stakingAdpRemote
			.fetchStakeableInfo(assetId)
			.pipe(take(1))
			.subscribe((stakeableInfo: GetStakeableDataByIdQuery) => {
				const isStakeable: boolean = stakeableInfo.assetConfig.assets.length > 0;
				const stakeable: Stakeable = isStakeable
					? this.stakingHelperService.processStakeableInfo(stakeableInfo)
					: null;
				this.updateStakeable(stakeable);
			});
	}
}
